import { useGetQueryParam } from '../../app/hooks/useGetQueryParam';
import { useSetQueryParams } from '../../app/hooks/useSetQueryParams';
import { useEffect } from 'react';
import { trackEmailEngagement, trackEmailEngagementWithProductUpdateId } from '../../app/utils/tracking';
function useEmailTracker({
  portalId,
  userId
}) {
  const setQueryParams = useSetQueryParams();
  const emailIdempotentId = useGetQueryParam('email');
  const productUpdateId = useGetQueryParam('update') || '';
  useEffect(() => {
    if (portalId && userId && emailIdempotentId !== null) {
      if (productUpdateId) {
        trackEmailEngagementWithProductUpdateId({
          portalId: portalId.toString(),
          userId: userId.toString(),
          emailIdempotentId,
          productUpdateId
        });
      } else {
        trackEmailEngagement({
          portalId: portalId.toString(),
          userId: userId.toString(),
          emailIdempotentId
        });
      }
      setQueryParams({
        email: ''
      });
    }
  }, [emailIdempotentId, portalId, productUpdateId, setQueryParams, userId]);
}
export default useEmailTracker;